export default "__VITE_ASSET__fMSu5bUY__"